import {axiosAPI} from "./API";

interface UploadUrlResponse {
    data: {
        signedUrl: string,
        bucketUrl: string,
        bucketKey: string,
    }
}

interface DownloadUrlResponse {
    data: {
        signedUrl: string,
        bucketUrl: string,
        bucketKey: string,
    }
}

interface UploadResponse {
    data: {
        bucketUrl: string,
        bucketKey: string,
    }
}

interface DownloadRequest {
    replayUUID: string
}

interface DownloadResponse {
    data: {
        bucketUrl: string,
        bucketKey: string,
    }
}

// Singleton for interacting with file uploads/downloads
class _FileService {

    public upload = async (file: File): Promise<UploadResponse> => {

        if (file.name == "") return;

        let response: UploadResponse = {data: {
            bucketUrl: "",
            bucketKey: ""
        }}

        let signedUrl = "";
        await axiosAPI.get<UploadUrlResponse>(`/upload?filename=${file.name}`)
            .then((resp) => {
                signedUrl = resp.data.data.signedUrl;
                response.data.bucketUrl = resp.data.data.bucketUrl;
                response.data.bucketKey = resp.data.data.bucketKey;
            })
            .catch((err) => {
                console.error("Error getting url for upload: ", err);
                throw err;
            });

        if (signedUrl == "" || response.data.bucketUrl == "" || response.data.bucketKey == "") return;

        return axiosAPI.put(signedUrl, file, { 
                transformRequest: this.removeAuthHeader,
                headers: {"Content-Type": file.type},
            })
            .then(() => {
                return response;
            })
            .catch((err) => {
                console.error("Error putting file upload: ", err);
                throw err;
            });
    }

    public download  = async (req: DownloadRequest): Promise<void> => {

        let response: DownloadResponse = {data: {
            bucketUrl: "",
            bucketKey: ""
        }}

        let signedUrl = "";
        await axiosAPI.get<DownloadUrlResponse>(`/download?replayUUID=${req.replayUUID}`)
            .then((resp) => {
                signedUrl = resp.data.data.signedUrl;
                response.data.bucketUrl = resp.data.data.bucketUrl;
                response.data.bucketKey = resp.data.data.bucketKey;
            })
            .catch((err) => {
                console.error("Error getting url for download: ", err);
                throw err;
            });

        if (signedUrl == "" || response.data.bucketUrl == "" || response.data.bucketKey == "") return;


        window.open(signedUrl)
    }

    // utility function to remove auth header from axios request for presigned url
    // s3 presigned url only allows one auth type, so need to remove existing axios auth header for that request
    removeAuthHeader = (data, headers) => {
        delete headers.common['Authorization'];
        return data;
    }
}

export const FileService = new _FileService();
